import { GadgetSystemDominionId } from "../../database/DominionLiterals";
import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyPriceListKey,
  ShopifyPriceListPriceKey,
  ShopifyPriceListPriceToPriceListKey,
  ShopifyPriceListPriceToProductVariantKey,
  ShopifyPriceListPriceToShopKey,
  ShopifyProductVariantKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import { buildConnectionSpec, ConnectionModelSpecVersion } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyPriceListPriceKey,
  "2024-04": {
    name: "Shopify Price List Price",
    fields: [
      {
        name: "ID",
        key: `${ShopifyPriceListPriceKey}-system-id`,
        fieldType: FieldType.ID,
        dominionID: GadgetSystemDominionId,
      },
      {
        name: "Compare At Price",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "compareAtPrice",
            graphQLSelection: `
            amount
            currencyCode`,
          },
        },
      },
      {
        name: "Origin Type",
        fieldType: FieldType.Enum,
        configuration: {
          allowMultiple: false,
          allowOther: true,
          options: [{ name: "FIXED" }, { name: "RELATIVE" }],
        },
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "originType", isShopifyEnum: true } },
      },
      {
        name: "Price",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "price",
            graphQLSelection: `
            amount
            currencyCode`,
          },
        },
      },
      {
        name: "Variant",
        fieldType: FieldType.BelongsTo,
        key: ShopifyPriceListPriceToProductVariantKey,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "variantId", skipGraphQLSelection: true } },
        configuration: {
          relatedModelKey: ShopifyProductVariantKey,
        },
      },
      {
        name: "Price List",
        fieldType: FieldType.BelongsTo,
        key: ShopifyPriceListPriceToPriceListKey,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "priceListId", skipGraphQLSelection: true } },
        configuration: {
          relatedModelKey: ShopifyPriceListKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyPriceListPriceToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "graphql_sublist",
      resource: "priceList.prices",
      parent: "priceLists",
      additionalSelection: "variant { id }",
    },
  },
};

export const ShopifyPriceListPrice = ({ apiVersion }: { apiVersion: ShopifyApiVersion }) => buildConnectionSpec(specs, apiVersion);
